import React from "react";
import {
  formatIndianAmount,
  formatDaysAgo,
  getDisplayPrice,
} from "../Services/Helper";
import { useNavigate } from "react-router-dom";
const FeaturedProperties = (data) => {
     const navigate = useNavigate();
  const defaultImage = "assets/img/property/property-22.jpg";

  const imageSrc =
    typeof data?.Images === "string" && data.Images.trim() !== ""
      ? data.Images.split(",")[0].trim()
      : defaultImage;

      
    const handleNavigate = () => {

      const tabID =
      data?.PropertyTypeID === 1 &&
      data?.VerticalID === 1
        ? 384
        : data?.PropertyTypeID === 1 &&
          data?.VerticalID === 2
        ? 385
        : data?.PropertyTypeID === 1 &&
          data?.VerticalID === 3
        ? 386
        : data?.PropertyTypeID === 2 &&
          data?.VerticalID === 1
        ? 387
        : 388;


          navigate(`/property-details?id=${data?.ListingID}`, {
        state: {
          TabID: tabID,
        },
      });



    }


  return (
    <div onClick={handleNavigate} className="col-lg-12 col-md-12 col-sm-6 col-xs-6">
      <div
        className="property-card style4 d-flex listpro"
        data-aos="fade-up"
        data-aos-duration={1200}
        data-aos-delay={400}
      >
        <div className="property-img" style={{ width: '40%' }}>
          <img src={imageSrc} alt="Property" />


          <div className="chipps chippss">
            {data.FeaturedID === 1 && (
            <span className="property-condo">Featured</span>
            )}
            <span className="property-status">
              <i className="ri-heart-fill" />
            </span>
          </div>

        </div>
        <div className="property-info" style={{ width: '60%' }}>
          <h3>
            <a >{data.Title}</a>
          </h3>
          <p>
            <i className="flaticon-location" />
            {data.Locality}
          </p>

          <div className="headss">
            <ul
              className="property-metainfo list-style lst1"
              style={{ marginTop: 10, whiteSpace: "nowrap" }}
            >
              {Array.isArray(data?.UnitFurnishingtitle) &&
                data?.UnitFurnishingtitle?.length > 0 &&
                data?.UnitFurnishingtitle?.slice(0, 3)?.map((title, index) => (
                  <li key={index}>
                    <img
                      src={title?.UnitFurnishingIcon}
                      alt="Furniture"
                      style={{ height: 20, width: 20 }}
                    // className="furnishing-icon"
                    />
                    {title?.Quantity}
                  </li>
                ))}
            </ul>
          </div>
          <div className="filterownerchip">
            {/* <div className="agent d-flex">
                <div className="chipsn"> <i className="ri-shield-check-line"></i> Agent</div>
                <span>Ravi Mehta</span>
            </div>
            
             <div className="owner d-flex">
                <div className="chipsn"> <i className="ri-shield-check-line"></i> Owner</div>
                <span>Ravi Mehta</span>
            </div> */}


             <div className="builder d-flex">
                <div className="chipsn"> <i className="ri-shield-check-line"></i> Builder</div>
                <span>{data.SellerName}</span>
            </div>
          </div>
          <div className="d-flexx border-top pdt-10">
            <p className="property-price">{getDisplayPrice(data)}</p>

            <div style={{width:200, textAlign:'right'}}>
            <button type="" className="btn style2">
               <i className="ri-phone-line" /> Call
            </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturedProperties;
